import React from "react";
export const PaginationContext = React.createContext({});
